import { Flex } from '@chakra-ui/react';
import { TagItem } from './TagItem';

export function ListTags({ listTags }) {
  if (listTags?.length === 0 || !listTags) return null;

  return (
    <Flex flexWrap="wrap" gap={2} mt={5} alignItems="center">
      Tags do segmento:{' '}
      {listTags?.map((tag) => (
        <TagItem key={tag.id} tag={tag} />
      ))}
    </Flex>
  );
}
